// import { Controller } from 'react-hook-form';
import Button from "../../../button/button";


interface DynamicButtonProps {
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  size?: 'small' | 'medium' | 'large';
}

// { control, index }

const DynamicButton = (props: DynamicButtonProps) => {
  const { type, onClick, className, disable, ...rest } = props;

  return (
    <Button
      type={type}
      onClick={onClick}
      className={className}
      {...rest}
      disabled={disable}
    >
      {props.text}
    </Button>
  );
};
export { DynamicButton };
export default DynamicButton;
